module.exports = __webpack_public_path__ + "img/subject_banner15.030086c8.png";